import React from "react";
import { Navigate } from "react-router-dom";

// Profile
import UserProfile from "../pages/Authentication/user-profile";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import ProjectsList from "../pages/Projects/projects-list";

// Dashboard
import Dashboard from "../pages/Dashboard/index";

const authProtectedRoutes = [
];

const publicRoutes = [
  { path: "/", component: <ProjectsList />}
];

export { authProtectedRoutes, publicRoutes };
